import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>

      <div className="foot-links">
        <h6>© 2023 Rummage Inc. &nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp; </h6> 
        <h6><a href="mailto:info@rummage.shop">info@rummage.shop </a> &nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;</h6>
        <h6><a href="https://www.boilerplate.co/terms-of-service">Terms of Service</a> / <a href="https://www.boilerplate.co/privacy-policy">Privacy Policy</a></h6>
      </div>
    </div>
  )
}

export default Footer